var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLegacy = function SvgLegacy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 9.33333L11.1111 12.8889L9.33333 11.1111M4.07682 5.59853C4.07682 5.59853 9.56209 6.21053 12 2C14.4379 6.21053 19.9232 5.59853 19.9232 5.59853C20.9136 19.8947 12 22 12 22C12 22 3.08643 19.8947 4.07682 5.59853Z",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgLegacy;